import {
  Scene,
  Vector3,
  PerspectiveCamera,
  WebGLRenderer,
  Plane,
  Color,
} from 'three';

import queryString from 'query-string';
import CircleLayout from '../CircleLayout';

const queryParams = queryString.parse(window.location.search);
export default {
  name: 'Scene',
  components: { CircleLayout },
  data() {
    return {
      scene: new Scene(),
      camera: new PerspectiveCamera(
        80,
        window.innerWidth / window.innerHeight,
        0.1,
        1000,
      ),
      renderer: new WebGLRenderer({ antialias: true, alpha: true }),
      mousePos: null,
      message: queryParams.text || 'Bam!',
      fontSize: queryParams.fontSize || 42,
      fontFamily: queryParams.fontFamily || 'Mansalva',
      fontWeight: queryParams.fontWeight || 800,
      background: queryParams.background || false,
      color: queryParams.color || '#FFFFFF',
    };
  },
  provide() {
    return {
      scene: this.scene,
    };
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize, false);
  },
  created() {
    if (this.background) {
      this.scene.background = new Color(this.background);
    }
    this.renderer.setPixelRatio(
      window.devicePixelRatio ? window.devicePixelRatio : 1,
    );
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.camera.position.set(0, 0, 30);
    this.camera.lookAt(new Vector3(0, 0, 0));

    this.planeZ = new Plane(new Vector3(0, 0, 1), 0);
  },
  mounted() {
    this.$refs.sceneContainer.appendChild(this.renderer.domElement);
    window.addEventListener('resize', this.handleResize);
    this.animateLoop();
  },
  methods: {
    handleResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animateLoop() {
      requestAnimationFrame(() => {
        this.animateLoop();
      });
      this.renderer.render(this.scene, this.camera);
    },
    onMouseMove($event) {
      const x = $event.touches
        ? $event.touches[0].clientX
        : $event.changedTouches
          ? $event.changedTouches[0].clientX
          : $event.clientX;
      const y = $event.touches
        ? $event.touches[0].clientY
        : $event.changedTouches
          ? $event.changedTouches[0].clientY
          : $event.clientY;
      this.mousePos = this.getXY(x, y);
    },
    onClick() {
      this.$refs.circleLayout.explode();
    },
    getXY(cX, cY) {
      const vec = new Vector3(); // create once and reuse
      const pos = new Vector3(); // create once and reuse

      vec.set(
        (cX / window.innerWidth) * 2 - 1,
        -(cY / window.innerHeight) * 2 + 1,
        0.5,
      );

      vec.unproject(this.camera);

      vec.sub(this.camera.position).normalize();

      const distance = -this.camera.position.z / vec.z;

      pos.copy(this.camera.position).add(vec.multiplyScalar(distance));

      return pos;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Scene/script.js